import React from 'react';
import ErrorFallback from './ErrorFallback';
import { logRouteError } from '../../routing/routeDiagnostics';

export default class AppErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, errorInfo) {
    logRouteError(this.props.context || 'app', error, errorInfo);
  }

  handleRetry = () => {
    this.setState({ error: null });
  };

  render() {
    const { error } = this.state;
    if (error) {
      return (
        <ErrorFallback
          error={error}
          compact={this.props.compact}
          showDashboardLink={this.props.showDashboardLink !== false}
          onReload={() => window.location.reload()}
          onRetry={this.handleRetry}
          title={this.props.title}
          message={this.props.message}
        />
      );
    }
    return this.props.children;
  }
}
